export default () => {
  $(() => {
    const slickSelector = '.js-image-gallery'

    $(slickSelector).slick({
      centerMode: false,
      draggable: false,
      infinite: true,
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      nextArrow: '<button type="button" class="widgets-image-gallery__button widgets-image-gallery__button--right"></button>',
      prevArrow: '<button type="button" class="widgets-image-gallery__button widgets-image-gallery__button--left"></button>',
      speed: 500
    })
  })
}
